import React, { Fragment } from 'react';
import ExpandedFundAgreementTypeHeader from '../../Buy/BuyFlow/ExpandedFundList/ExpandedFundAgreementTypeHeader';
import { ExpandedFundClassificationTypeHeader } from '../../Buy/BuyFlow/ExpandedFundList/ExpandedFundClassificationTypeHeader';
import { PRODUCT_TYPE_LABEL_MAP } from '../../../settings/settings';

const CollegeContributeFundGroupHeader = ({ fund, lastFund }) => {
  const firstOfNames =
    lastFund.formattedEntityNames !== fund.formattedEntityNames;
  const firstOfProductType =
    firstOfNames || lastFund.productType !== fund.productType;

  return (
    <Fragment>
      {firstOfNames && (
        <ExpandedFundClassificationTypeHeader>
          <span className="blocked_data">{fund.formattedEntityNames}</span>
        </ExpandedFundClassificationTypeHeader>
      )}
      {firstOfProductType && (
        <ExpandedFundAgreementTypeHeader
          agreementType={PRODUCT_TYPE_LABEL_MAP[fund.productType]}
          productType={fund.productType}
        />
      )}
    </Fragment>
  );
};

export default CollegeContributeFundGroupHeader;
